<template>
    <component :is="tag" class="wtc-place-holder">{{ text }}</component>
</template>
<script setup lang="ts">
defineProps({
    tag: {
        type: String,
        default: "div"
    },
    text: {
        type: String,
        default: ""
    }
});
</script>
<style></style>
